import { edgeFunctions } from '../lib/supabase'
import { parseEdgeFunctionError } from './comercialCotacoes'
import { validatePassword } from '../utils/userValidation'

export interface AdminPasswordResetResult {
  success: boolean
  error?: string
}

export async function resetUserPasswordAsAdmin(
  userId: string,
  password: string,
  confirmPassword: string,
): Promise<AdminPasswordResetResult> {
  const validation = validatePassword(password, confirmPassword)
  if (!validation.isValid) {
    return { success: false, error: validation.error }
  }

  const { data, error } = await edgeFunctions.invoke('admin-reset-user-password', {
    userId,
    password,
  })

  if (error) {
    return { success: false, error: parseEdgeFunctionError(error, data) }
  }

  const payload = (data ?? {}) as { success?: boolean; error?: string }
  if (payload.error) {
    return { success: false, error: parseEdgeFunctionError(null, payload) }
  }

  if (!payload.success) {
    return { success: false, error: 'Não foi possível alterar a senha.' }
  }

  return { success: true }
}
